import { TextWithSubTitle } from "../../../../../../components/textWithSubTitle";
import React from "react";
import { WithRoleLinkToolTip } from "../../../../../../components/RoleLinkToolTip";
import UserForReviewTask from "src/components/user-for-review-task";

export function userAccessColumnGenerator(columns, accessTypeLink) {
  return columns?.map((column, columnIndex) => {
    let { render, identifier, ...restKeys } = column;
    let titleStyles = {};
    if (columnIndex === 0) {
      restKeys = {
        ...restKeys,
        fixed: "left",
      };
      titleStyles = { fontWeight: 600, ...titleStyles };
    }
    if (render === "TextWithSubTitleComponent") {
      if (column.title === "User") {
        render = (titles) => <UserForReviewTask userDetails={titles} />;
      } else {
        render = (titles, record) => (
          <>
            {accessTypeLink ? (
              <WithRoleLinkToolTip
                accessTypeLink={accessTypeLink}
                column={column}
                dataTestId={`role-link-${record.key}`}
              >
                <TextWithSubTitle titles={titles} titleStyles={titleStyles} />
              </WithRoleLinkToolTip>
            ) : (
              <TextWithSubTitle titles={titles} titleStyles={titleStyles} />
            )}
          </>
        );
      }
    } else {
      render = (text, record) => (
        <>
          {accessTypeLink ? (
            <WithRoleLinkToolTip
              accessTypeLink={accessTypeLink}
              column={column}
              dataTestId={`role-link-${record.key}`}
            >
              {text}
            </WithRoleLinkToolTip>
          ) : (
            text
          )}
        </>
      );
    }
    return { ...restKeys, render, width: 204 };
  });
}